// MAIN //

const textSpec = {
	group: 'inline'
};


// EXPORTS //

export default textSpec;
